export default __webpack_public_path__ + "static/media/Netflix.f41a2cc9.jpg";